"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ISDATE = void 0;
exports.ISDATE = {
    alias: 'ISDATE',
    description: 'Valida se um dado valor é uma data. Retorna false se não for uma data',
    arg_names: ['value_to_validate'],
    args_description: ['valor a ser checado'],
    target_date_format: 'dd/MM/yyyy',
    source_date_format: 'yyyy-MM-dd',
};
